import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function IdentityClose() {
  return <section className="py-24 px-6 bg-bg-main relative overflow-hidden" data-id="element-84">
      {/* Background gradient */}
      <div className="absolute bottom-0 left-0 w-full h-[500px] bg-gradient-to-t from-brand-purple/10 to-transparent pointer-events-none" data-id="element-85" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-86">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-20" data-id="element-87">
          <h2 className="text-3xl md:text-5xl font-serif text-text-primary mb-8" data-id="element-88">
            La parte que casi nadie te dice
          </h2>
          <p className="text-xl text-text-secondary mb-6" data-id="element-89">
            (pero tú ya lo sabes)
          </p>
          <div className="text-lg md:text-xl text-text-secondary space-y-6 leading-relaxed" data-id="element-90">
            <p data-id="element-91">
              El gasto impulsivo no es un tema de Excel.{' '}
              <span className="text-text-primary font-medium" data-id="element-92">
                Es un tema de identidad.
              </span>
            </p>
            <p data-id="element-93">
              Hay una versión tuya que compra para calmarse… porque no sabe cómo
              descansar sin pagar por eso.
            </p>
            <p className="text-2xl font-serif text-brand-gold italic pt-4" data-id="element-94">
              Este workbook no te juzga. Te devuelve el control.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-b from-bg-secondary to-bg-main border border-brand-gold/20 p-10 md:p-14 rounded-3xl shadow-2xl shadow-brand-gold/5" id="precio" data-id="element-95">
          <div className="mb-8" data-id="element-96">
            <span className="text-text-secondary text-sm uppercase tracking-widest mb-2 block" data-id="element-97">
              Precio Especial de Lanzamiento
            </span>
            <div className="flex items-center justify-center gap-3" data-id="element-98">
              <span className="text-2xl md:text-3xl font-serif text-text-muted line-through opacity-50" data-id="element-99">
                $14
              </span>
              <span className="text-lg text-text-muted line-through opacity-50" data-id="element-100">
                USD
              </span>
            </div>
            <div className="flex items-center justify-center gap-2 mt-1" data-id="element-101">
              <span className="text-5xl md:text-6xl font-serif text-brand-gold" data-id="element-102">
                $7
              </span>
              <span className="text-xl text-text-secondary self-start mt-2" data-id="element-103">
                USD
              </span>
            </div>
            <span className="inline-block mt-3 px-3 py-1 text-xs font-medium uppercase tracking-wider bg-brand-gold/10 text-brand-gold border border-brand-gold/20 rounded-full" data-id="element-104">
              -50% descuento
            </span>
          </div>

          <p className="text-text-muted text-sm mb-10 max-w-md mx-auto" data-id="element-105">
            (Una sola compra impulsiva promedio suele costar más que esto. Y
            esta vez, la compra te deja sistema.)
          </p>

          <a href="https://vialibre360.com/cart/46479856500894:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="group relative w-full md:w-auto px-8 py-4 bg-brand-gold text-bg-main font-bold text-lg rounded-full hover:bg-white transition-all duration-300 shadow-[0_0_20px_rgba(201,168,76,0.3)] hover:shadow-[0_0_30px_rgba(255,255,255,0.4)] flex items-center justify-center mx-auto" data-id="element-106">
            <span data-id="element-107">Obtener Anti-Impulso Ahora</span>
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-108" />
          </a>

          <p className="mt-8 text-text-muted text-xs" data-id="element-109">
            Acceso inmediato · Pago seguro · Garantía de satisfacción
          </p>
        </motion.div>

        <div className="mt-16 text-text-secondary" data-id="element-110">
          <p className="mb-4" data-id="element-111">
            Si hoy te sientes cansada de empezar cada mes desde cero, este es tu
            siguiente paso:
          </p>
          <p className="font-serif text-xl text-text-primary" data-id="element-112">
            Anti-Impulso: "Cierra el Mes" — 30 días. Sistema simple. Control
            real.
          </p>
        </div>
      </div>
    </section>;
}